<div class="surface-card p-6">
  <!-- Header -->
  <div class="flex items-center justify-between mb-6">
    <div>
      <h2 class="text-text-primary text-xl font-semibold mb-1">{{ 'seekerDashboard.bookings.title' | translate }}</h2>
      <p class="text-text-secondary text-sm">
        <ng-container *ngIf="!loading">
          {{ bookings.length }} {{ bookings.length !== 1 ? ('seekerDashboard.bookings.subtitleTotalPlural' | translate)
          : ('seekerDashboard.bookings.subtitleTotal' | translate) }} {{ 'seekerDashboard.bookings.subtitleSuffix' |
          translate }}
        </ng-container>
      </p>
    </div>
    <div class="w-12 h-12 flex items-center justify-center rounded-xl bg-surface-elevated text-success border border-border">
      <i class="fa-solid fa-house text-xl"></i>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center py-16">
    <i class="fas fa-spinner fa-spin text-3xl text-primary"></i>
  </div>

  <!-- Error -->
  <div *ngIf="error && !loading" class="alert alert-danger max-w-md mx-auto items-center justify-between text-center rounded-2xl shadow-elevated mb-4">
    <span>{{ error }}</span>
  </div>

  <!-- Empty -->
  <div *ngIf="!loading && !error && bookings.length === 0" class="text-center py-16">
    <div class="w-16 h-16 bg-surface-elevated rounded-full flex items-center justify-center mx-auto mb-4 border border-border-subtle">
      <i class="fa-solid fa-calendar-xmark text-text-muted text-2xl"></i>
    </div>
    <p class="text-text-secondary text-sm">{{ 'seekerDashboard.bookings.noBookings' | translate }}</p>
  </div>

  <!-- Booking List -->
  <div *ngIf="!loading && !error && bookings.length > 0" class="space-y-4">
    <div *ngFor="let booking of bookings"
      class="surface-card overflow-hidden hover:-translate-y-1 hover:border-primary/50 transition duration-300">
      <div class="md:flex">
        <!-- Image -->
        <div class="w-full md:w-48 h-48 flex-shrink-0 bg-surface-elevated">
          <img [src]="booking.image" [alt]="booking.title" class="w-full h-full object-cover transition duration-500 hover:scale-105"
            onerror="this.src = ''" />
        </div>

        <!-- Content -->
        <div class="flex-1 p-5">
          <div class="flex items-start justify-between mb-3">
            <div>
              <h3 class="text-text-primary font-semibold mb-1 hover:text-primary transition-colors cursor-pointer">{{ booking.title }}</h3>
              <div class="flex items-center gap-1 text-text-secondary text-sm">
                <i class="fa-solid fa-location-dot text-text-muted text-xs"></i>
                <span>{{ booking.location }}</span>
              </div>
            </div>
            <span class="badge text-xs font-medium whitespace-nowrap"
              [ngClass]="statusClass(booking.status)">
              {{ booking.statusLabel || booking.status }}
            </span>
          </div>

          <!-- Dates & Price -->
          <div class="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4 text-sm">
            <div>
              <div class="text-xs text-text-muted mb-0.5 uppercase tracking-wider font-mono">{{ 'seekerDashboard.bookings.checkIn' | translate }}</div>
              <div class="text-text-primary font-medium">{{ formatDate(booking.arrivalDate) }}</div>
            </div>
            <div>
              <div class="text-xs text-text-muted mb-0.5 uppercase tracking-wider font-mono">{{ 'seekerDashboard.bookings.checkOut' | translate }}</div>
              <div class="text-text-primary font-medium">{{ formatDate(booking.departureDate) }}</div>
            </div>
            <div>
              <div class="text-xs text-text-muted mb-0.5 uppercase tracking-wider font-mono">{{ 'seekerDashboard.bookings.rentalType' | translate }}</div>
              <div class="text-text-primary capitalize">{{ booking.rentalType }}</div>
            </div>
            <div>
              <div class="text-xs text-text-muted mb-0.5 uppercase tracking-wider font-mono">{{ 'seekerDashboard.bookings.price' | translate }}</div>
              <div class="text-primary font-semibold">
                {{ booking.price | number }} {{ booking.currency }}
              </div>
            </div>
          </div>

          <!-- Booked on -->
          <p class="text-xs text-text-muted mb-4 font-mono">{{ 'seekerDashboard.bookings.bookedOn' | translate }} {{
            formatDate(booking.createdAt) }}</p>

          <!-- Actions -->
          <div class="flex flex-wrap gap-2">
            <button (click)="contactOwner(booking)"
              class="btn btn-primary px-4 py-2 text-sm flex items-center gap-2">
              <i class="fa-solid fa-message text-xs"></i> {{ 'seekerDashboard.bookings.contactOwner' | translate }}
            </button>
            <button (click)="openTicketModal(booking)"
              class="btn btn-secondary px-4 py-2 text-sm flex items-center gap-2">
              <i class="fa-solid fa-ticket text-xs"></i> {{ 'ticket.createNew' | translate }}
            </button>
            <button (click)="viewUnit(booking)"
              class="btn btn-secondary px-4 py-2 text-sm flex items-center gap-2">
              <i class="fa-solid fa-eye text-xs"></i> {{ 'seekerDashboard.bookings.viewUnit' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-ticket-creation-modal
    [show]="showTicketModal"
    defaultRelatedType="booking"
    [defaultRelatedId]="selectedBookingForTicket?.bookingId || ''"
    (close)="closeTicketModal()"
    (ticketCreated)="onTicketCreated()">
  </app-ticket-creation-modal>
</div>
